import { useRef } from 'react'

import { Button } from 'antd'

import { RotateButtonProps } from './interface'

export const RotateButton = ({ icon, onRotate }: RotateButtonProps) => {
  const timerRef = useRef<number>(undefined)
  const handleMouseDown = () => {
    onRotate()
    timerRef.current = setInterval(onRotate, 150)
  }

  const handleMouseUp = () => {
    clearInterval(timerRef.current)
  }
  return (
    <Button
      icon={icon}
      type='text'
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    />
  )
}
